import React, { useState } from 'react';
import { object } from 'prop-types';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { FormattedMessage } from '../../util/reactIntl';
import { getListingFaq, isShowableFaqItem } from '../../util/listingPackages';
import { renderRichText } from '../../util/richTextRender';

import css from './SectionFaq.css';

const answerId = index => `listing-faq-answer-${index}`;

// Figma 314:1892: the FAQ as an accordion of "Service page / FAQ row"s
// (314:1907), the first one open. Each row opens and closes on its own, like
// the <details> the DS row is modelled on. Closed answers stay in the HTML.
const FaqList = ({ items }) => {
  const [openIndexes, setOpenIndexes] = useState([0]);
  const toggle = index =>
    setOpenIndexes(open =>
      open.includes(index) ? open.filter(i => i !== index) : [...open, index]
    );

  return (
    <div className={css.list}>
      {items.map((item, index) => {
        const isOpen = openIndexes.includes(index);
        const Chevron = isOpen ? LuChevronUp : LuChevronDown;
        return (
          <div className={css.item} key={index}>
            <h3 className={css.question}>
              <button
                type="button"
                className={css.questionButton}
                aria-expanded={isOpen}
                aria-controls={answerId(index)}
                onClick={() => toggle(index)}
              >
                <span className={css.questionText}>{item.question}</span>
                <Chevron className={css.chevron} aria-hidden="true" />
              </button>
            </h3>
            <div id={answerId(index)} className={css.answer} hidden={!isOpen}>
              {renderRichText(item.answer)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

// Old listings' plain-text rules, shown in this slot until the author saves an
// FAQ (spec §5.7). sanitizeListing has already run them through sanitizeText;
// they render as text with their line breaks, never as HTML.
const SectionFaq = props => {
  const { listing } = props;
  const faq = getListingFaq(listing).filter(isShowableFaqItem);
  const publicData = (listing && listing.attributes && listing.attributes.publicData) || {};
  const rules = typeof publicData.rules === 'string' ? publicData.rules.trim() : '';

  if (faq.length === 0 && !rules) {
    return null;
  }

  return (
    <section className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id={faq.length > 0 ? 'SectionFaq.title' : 'SectionFaq.rulesTitle'} />
      </h2>
      {faq.length > 0 ? (
        // Keyed by listing so the open rows reset when another listing loads.
        <FaqList key={listing.id ? listing.id.uuid : null} items={faq} />
      ) : (
        <p className={css.rules}>{rules}</p>
      )}
    </section>
  );
};

SectionFaq.propTypes = {
  listing: object.isRequired,
};

export default SectionFaq;
